import AddressLineOne from './AddressLineOne';


class TownCity extends AddressLineOne {
    static defaultProps = {
        'field': 'townCity',
        'id': 'towncity',
        'name': 'towncity'
    };
}


export default TownCity;
